import { gaInitialize } from './gaInitialize';
import { combineReducers } from 'redux';
const rootReducer = combineReducers({
  gaInitialize,
});
export default rootReducer;
